import CityPageTemplate from "@/components/site/CityPageTemplate";

export default function FinanzberatungVillingenSchwenningen() {
  return (
    <CityPageTemplate
      city="Villingen-Schwenningen"
      slug="villingen-schwenningen"
      intro="Villingen-Schwenningen als Uhrenstadt im Schwarzwald – Deine Finanzen sollten genauso präzise getaktet sein."
      description="Unabhängige & digitale Finanzberatung für Villingen-Schwenningen: Altersvorsorge, ETF, Steueroptimierung und staatliche Förderungen. Kostenlose Erstberatung – 100% digital."
    />
  );
}
